/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-06-25 18:03:01
 * description  : 描述
 * author       : zhizhan
 */
import React from "react";
import { Tooltip } from "antd";
import Icon from "../YxText/Icon";
import { isString } from "lodash";
import { get } from "../../utils";
import YxAction from "../YxAction";

/**
 * 渲染提示信息组件
 *
 * @export
 * @param {*} props
 * @returns
 */
export default function (props) {
  const describe = get(props, "describe", "");
  const iconName = "question";
  const renderImg = function () {
    const [url, type = "Image"] = describe.split("||");
    const children = type === "Image" ? <img src={url} /> : <video src={url} />;
    const popupParam = {
      title: "详细说明",
      children,
      className: "describe_modal",
    };
    const baseParam = {
      popupParam,
      type: iconName,
      title: "点击详细说明",
      styleType: "icon",
      actionType: "popup",
    };
    return <YxAction {...baseParam} />;
  };

  const renderString = function () {
    return (
      <Tooltip title={describe}>
        <Icon type={iconName} />
      </Tooltip>
    );
  };

  const render = function () {
    if (!isString(describe)) {
      console.error("describe若传入必须为字符串");
      return null;
    } else if (describe.includes("||")) {
      return renderImg();
    } else {
      return renderString();
    }
  };
  return <div className="or_describe">{render()}</div>;
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxIncrementForm/Describe.js